/**
 * Hand-authored 16x16 pixel art (Turkish everyday icons). Each sprite is a 16-row string grid;
 * characters map to palette indices via `key`, '.' is transparent.
 * These are the first content pack; tools/art-factory will add generated images later.
 */
export interface PixelSpriteDef {
  id: string;
  name: string; // Turkish display name
  nameEn: string; // English display name
  key: Record<string, string>; // char -> hex color
  rows: string[]; // 16 rows x 16 chars
}

export const SPRITES: PixelSpriteDef[] = [
  {
    id: "nazar",
    name: "Nazar boncuğu",
    nameEn: "Evil eye bead",
    key: { b: "#1b4fd8", w: "#ffffff", c: "#7cc4ff", k: "#0b1a3a", h: "#a9d6ff" },
    rows: [
      "......bbbb......",
      "....bbbbbbbb....",
      "...bbbbbbbbbb...",
      "..bbbwwwwwwbbb..",
      ".bbbwwwwwwwwbbb.",
      ".bbwwwccccwwwbb.",
      "bbbwwccccccwwbbb",
      "bbbwwcckkccwwbbb",
      "bbbwwckkhkcwwbbb",
      "bbbwwcckkccwwbbb",
      ".bbwwwccccwwwbb.",
      ".bbbwwwwwwwwbbb.",
      "..bbbwwwwwwbbb..",
      "...bbbbbbbbbb...",
      "....bbbbbbbb....",
      "......bbbb......",
    ],
  },
  {
    id: "cay",
    name: "Çay bardağı",
    nameEn: "Tea glass",
    key: { g: "#e8eef7", t: "#c8451c", d: "#8f2a10", s: "#ffffff", p: "#d9d9d9", r: "#b23a15" },
    rows: [
      "................",
      "...gggggggggg...",
      "...gssttttssg...",
      "...gttttttttg...",
      "....gttttttg....",
      "....gttttttg....",
      ".....gttttg.....",
      ".....gttttg.....",
      ".....gddddg.....",
      "......gddg......",
      "......gddg......",
      ".....gddddg.....",
      ".....gggggg.....",
      "...pppppppppp...",
      "..pppppppppppp..",
      "................",
    ],
  },
  {
    id: "simit",
    name: "Simit",
    nameEn: "Simit",
    key: { o: "#d98a2b", d: "#a85f16", s: "#f6d9a0", h: "#f0b25a" },
    rows: [
      "................",
      ".....oooooo.....",
      "...ooshhshsoo...",
      "..oshoooooohso..",
      ".oshoo....oohso.",
      ".ohoo......oodo.",
      "osho........ohso",
      "osho........ohso",
      "ohoo........oodo",
      "osho........ohso",
      ".ohoo......oodo.",
      ".oshoo....oohso.",
      "..oshoooooohso..",
      "...ooshhshsoo...",
      ".....oooooo.....",
      "................",
    ],
  },
  {
    id: "kedi",
    name: "Sokak kedisi",
    nameEn: "Street cat",
    key: { k: "#f2a541", d: "#c77f1d", w: "#ffffff", e: "#2b2d42", p: "#ff8fa3", n: "#e06a7a" },
    rows: [
      "..k..........k..",
      ".kkk........kkk.",
      ".kdkk......kkdk.",
      ".kkkkkkkkkkkkkk.",
      "kkkkkkkkkkkkkkkk",
      "kkkwwkkkkkkwwkkk",
      "kkkwekkkkkkewkkk",
      "kkkkkkkkkkkkkkkk",
      "kkkkkkknnkkkkkkk",
      "kkkkkkkkkkkkkkkk",
      ".kkkkkkkkkkkkkk.",
      "..kkkkkkkkkkkk..",
      "...kkdkkkkdkk...",
      "...kkkkkkkkkk...",
      "....kk....kk....",
      "....kk....kk....",
    ],
  },
  {
    id: "lale",
    name: "Lale",
    nameEn: "Tulip",
    key: { r: "#e63946", d: "#b81f2d", g: "#2a9d8f", l: "#1d6f65" },
    rows: [
      ".....r....r.....",
      "....rr.rr.rr....",
      "....rrrrrrrr....",
      "....rrrrrrrr....",
      "....rrrdrrrr....",
      "....drrrrrrd....",
      ".....drrrrd.....",
      "......dddd......",
      ".......gg.......",
      ".......gg.......",
      "...l...gg...l...",
      "...ll..gg..ll...",
      "....ll.gg.ll....",
      ".....llggll.....",
      ".......gg.......",
      ".......gg.......",
    ],
  },
  {
    id: "balik",
    name: "Balık",
    nameEn: "Fish",
    key: { b: "#1982c4", l: "#5ab0e6", w: "#ffffff", e: "#0b1a3a", f: "#146a9e" },
    rows: [
      "................",
      "................",
      ".......bbbb.....",
      ".....bbllbbb....",
      "....bbllllbbb..f",
      "...bblllllbbb.ff",
      "..bbbbbbbbbbbfff",
      ".bbwebbbbbbbbff.",
      "..bbbbbbbbbbbfff",
      "...bbbbbbbbbb.ff",
      "....bbbbbbbbb..f",
      ".....bbbbbbb....",
      ".......bbbb.....",
      "................",
      "................",
      "................",
    ],
  },
  {
    id: "kalp",
    name: "Kalp",
    nameEn: "Heart",
    key: { r: "#ff595e", d: "#c8323a", h: "#ff9aa0" },
    rows: [
      "................",
      "..rrrr....rrrr..",
      ".rrhrrr..rrrrrr.",
      "rrhhrrrrrrrrrrrr",
      "rrhrrrrrrrrrrrrr",
      "rrrrrrrrrrrrrrrr",
      "rrrrrrrrrrrrrrrd",
      ".rrrrrrrrrrrrrd.",
      "..rrrrrrrrrrrd..",
      "...rrrrrrrrrd...",
      "....rrrrrrrd....",
      ".....rrrrrd.....",
      "......rrrd......",
      ".......rd.......",
      "................",
      "................",
    ],
  },
  {
    id: "vapur",
    name: "Vapur",
    nameEn: "Ferry",
    key: { w: "#f1f1f6", b: "#1982c4", k: "#2b2d42", y: "#ffca3a", s: "#5ab0e6", g: "#8d8d8d" },
    rows: [
      "................",
      "........g.......",
      "........g.g.....",
      ".....kkkkkkk....",
      ".....kwwwwwk....",
      "..wwwwwwwwwwwww.",
      "..wywywywywywyw.",
      "..wwwwwwwwwwwww.",
      ".bbbbbbbbbbbbbbb",
      ".bbbbbbbbbbbbbb.",
      "..bbbbbbbbbbbb..",
      "...bbbbbbbbbb...",
      "ssssssssssssssss",
      ".ss.ss.ss.ss.ss.",
      "................",
      "................",
    ],
  },
  {
    id: "ayyildiz",
    name: "Ay yıldız",
    nameEn: "Crescent and star",
    key: { r: "#e30a17", w: "#ffffff" },
    rows: [
      "rrrrrrrrrrrrrrrr",
      "rrrrrrrrrrrrrrrr",
      "rrrrwwwrrrrrrrrr",
      "rrrwwwwwwrrrrrrr",
      "rrwwwrrrwwrrrrrr",
      "rrwwrrrrrrrrwrrr",
      "rwwwrrrrrrrwwwrr",
      "rwwwrrrrrrwwwwwr",
      "rwwwrrrrrrrwwwrr",
      "rrwwrrrrrrrrwrrr",
      "rrwwwrrrwwrrrrrr",
      "rrrwwwwwwrrrrrrr",
      "rrrrwwwrrrrrrrrr",
      "rrrrrrrrrrrrrrrr",
      "rrrrrrrrrrrrrrrr",
      "rrrrrrrrrrrrrrrr",
    ],
  },
  {
    id: "dondurma",
    name: "Dondurma",
    nameEn: "Ice cream",
    key: { p: "#ff8fa3", v: "#f4e1c1", c: "#d98a2b", d: "#a85f16", w: "#ffffff" },
    rows: [
      "................",
      ".....pppppp.....",
      "....pppwppppp...",
      "....ppppppppp...",
      "....vvvvvvvvv...",
      "...vvvwvvvvvvv..",
      "...vvvvvvvvvvv..",
      "....vvvvvvvvv...",
      "....ccccccccc...",
      "....cdcdcdcdc...",
      ".....cdcdcdc....",
      ".....cdcdcdc....",
      "......cdcdc.....",
      "......cdcdc.....",
      ".......cdc......",
      "........c.......",
    ],
  },
];

export const SPRITE_IDS = SPRITES.map((s) => s.id);
